import React, { FC, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Icon, TextField } from "@fluentui/react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { mergeStyleSets, Callout, DelayedRender } from "@fluentui/react";
import { State } from "../../../store";
import { convertStatusToName, toNominationNo } from "../../../services/Helper";
import RoundProgressIndicator from "../../nominations/RoundProgressIndicator";
import SofIcon from "../../common/Icons";
import * as SofViewStore from "../../../store/SofViewStore";
import * as GeneralStore from "../../../store/GeneralStore";
import { TruckNomination } from "../../../models";
import EtaButton from "../EtaButton2";
import { Patch } from "../../../api/apiUtils";
import moment from "moment";
import ProgressIndicator from "../../nominations/ProgressIndicator";

type Props = GeneralStore.GeneralState &
  typeof SofViewStore.actionCreators & {
    nomination: TruckNomination;
    onEtaUpdated(nomination: TruckNomination): void;
  } & {
    openAttachmentPanel: Function;
    setSelectedNomination: React.Dispatch<
      React.SetStateAction<string | undefined>
    >;
    modality: number;
    selectedTab: string;
  };

const classes = mergeStyleSets({
  viewButton: {
    width: "39px",
    height: "39px",
    borderRadius: "5px",
    //border: "1px solid #E2E6E8",
    //backgroundColor: "#FAFAFA",
    display: "block",
    padding: "6px 9px",
    marginRight: "10px",
    cursor: "pointer",
    textAlign: "center",
    selectors: {
      ":hover": {
        backgroundColor: "#EEEEEE",
        textDecoration: "none",
      },
    },
  },
  viewButtonUpload: {
    width: "39px",
    height: "39px",
    borderRadius: "5px",
    border: "1px solid #E2E6E8",
    backgroundColor: "#FAFAFA",
    display: "block",
    padding: "0",
    marginRight: "10px",
    cursor: "pointer",
    selectors: {
      ":hover": {
        backgroundColor: "#EEEEEE",
        textDecoration: "none",
      },
    },
  },
  viewIcon: {
    color: "#4C4C4C",
    margin: "auto",
    display: "block",
  },
  viewIconUpload: {
    color: "#4C4C4C",
    margin: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
    textAlign: "center",
  },
  arrowContainer: {
    width: 52,
  },
  collapsiblePanel: {
    overflow: "hidden",
    transition: "height 0.3s ease-out",
    height: 0,
  },
  ovalRejected: {
    width: "70px",
    height: "25px",
    background: "rgba(211, 47, 47, 0.2)",
    borderRadius: "50px",
    fontSize: "small",
    padding: "2px 5px",
    color: "#D32F2F",
    marginRight: "10px",
    marginTop: "7px",
    textAlign: "center",
  },
  callout: {
    width: 320,
    padding: "20px 24px",
  },
  mainPanel: {
    opacity: ".50",
  },
  listPanel: {
    width: 320,
    padding: "20px 24px",
  },
  previewPanel: {
    width: 320,
    padding: "20px 24px",
  },
});

const NominationItem2: FC<Props> = (props: Props) => {
  const location = useLocation();
  const { nomination, openAttachmentPanel, setSelectedNomination } = props;
  const [isExpand, setIsExpand] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);
  const [callOutId, setCallOutId] = useState("");
  const [assignedTo, setAssignedTo] = useState(nomination.assignedTo ?? "");
  const panel = useRef<HTMLDivElement>(null);
  const history = useHistory();

  const collapseSection = (element: HTMLDivElement) => {
    var sectionHeight = element.scrollHeight;

    var elementTransition = element.style.transition;
    element.style.transition = "";

    requestAnimationFrame(() => {
      element.style.height = sectionHeight + "px";
      element.style.transition = elementTransition;

      requestAnimationFrame(() => {
        element.style.height = 0 + "px";
      });
    });

    setIsExpanded(true);
  };

  const expandSection = (element: HTMLDivElement) => {
    var sectionHeight = element.scrollHeight;

    var event = (e: TransitionEvent) => {
      element.removeEventListener("transitionend", event);
      //element.style.height = "0";
    };

    element.style.height = sectionHeight + "px";
    element.addEventListener("transitionend", event);

    setIsExpanded(false);
  };

  const updateAssignedTo = async (name: string) => {
    if (name.length === 0) return;

    await Patch(
      `/api/nomination/${props.nomination.nominationNo}`,
      JSON.stringify([
        {
          op: "replace",
          path: "/assignedTo",
          value: name,
        },
      ])
    );
  };

  useEffect(() => {
    if (panel && panel.current) {
      if (isExpanded !== isExpand) return;

      if (isExpanded) {
        expandSection(panel.current);
        setIsExpanded(false);
      } else {
        collapseSection(panel.current);
      }
    }
  }, [isExpand]);

  return (
    <>
      <div
        key={`line-handling-${nomination.nominationNo}`}
        className="ms-Grid"
        dir="ltr"
        style={{ backgroundColor: "white", padding: "0px" }}
      >
        <div className="ms-Grid-row" style={{ padding: 20 }}>
          <div className="ms-Grid-col ms-md5">
            <div
              style={{ display: "flex", alignItems: "center", columnGap: 16 }}
            >
              <div
                style={{
                  display: "flex",
                  padding: 12,
                  justifyContent: "center",
                  borderRadius: 99,
                  background: "#F3F4F6",
                }}
              >
                <>
                  {nomination.transferType === "Tank to Truck" ||
                  nomination.transferType === "Tank to Rail Car" ? (
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="arrow_back">
                        <mask
                          id="mask0_6_1855"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="24"
                          height="24"
                        >
                          <rect
                            id="Bounding box"
                            width="24"
                            height="24"
                            fill="#D9D9D9"
                          />
                        </mask>
                        <g mask="url(#mask0_6_1855)">
                          <path
                            id="arrow_back_2"
                            d="M7.37302 12.75L13.0692 18.4461L12 19.5L4.5 12L12 4.5L13.0692 5.55383L7.37302 11.25H19.5V12.75H7.37302Z"
                            fill="#1C1B1F"
                          />
                        </g>
                      </g>
                    </svg>
                  ) : (
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="arrow_forward">
                        <mask
                          id="mask0_6_1843"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="24"
                          height="24"
                        >
                          <rect
                            id="Bounding box"
                            width="24"
                            height="24"
                            fill="#D9D9D9"
                          />
                        </mask>
                        <g mask="url(#mask0_6_1843)">
                          <path
                            id="arrow_forward_2"
                            d="M16.6269 12.75H4.5V11.25H16.6269L10.9308 5.55383L12 4.5L19.5 12L12 19.5L10.9308 18.4461L16.6269 12.75Z"
                            fill="#1C1B1F"
                          />
                        </g>
                      </g>
                    </svg>
                  )}
                </>
              </div>
              <div>
                <div
                  style={{ fontSize: 16, fontWeight: 700, lineHeight: "24px" }}
                >
                  {nomination.tank}
                </div>
                <div
                  style={{ fontSize: 14, fontWeight: 400, lineHeight: "24px" }}
                >
                  Nomination #: {toNominationNo(nomination.nominationNo)}
                </div>
              </div>
            </div>
          </div>
          <div className="ms-Grid-col ms-md3">
            <div style={{ fontSize: 14, fontWeight: 500, lineHeight: "24px" }}>
              <EtaButton
                nomination={nomination}
                onSuccess={(value: string) => {
                  nomination.eta = value;
                  props.onEtaUpdated(nomination);
                }}
              />
            </div>
            <div style={{ fontSize: 14, fontWeight: 400, lineHeight: "24px" }}>
              {convertStatusToName(nomination.status)} Date
            </div>
          </div>
          <div className="ms-Grid-col ms-md3">
            <ProgressIndicator
              label="Nomination"
              secondaryText={`${nomination.progress}%`}
              value={nomination.progress}
            />
          </div>
          <div
            className="ms-Grid-col ms-md1"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: 48,
            }}
          >
            <Link
              id={`lnk-${nomination.nominationNo}`}
              className={classes.viewButton}
              to={`${location.pathname}/${nomination.nominationNo}/sof`}
            >
              <Icon iconName="ChevronRight" className={classes.viewIcon} />
            </Link>
          </div>
        </div>
        {/*<div*/}
        {/*  onClick={() => setIsExpand((previousVal) => !previousVal)}*/}
        {/*  className="ms-Grid-row"*/}
        {/*  style={{*/}
        {/*    display: "flex",*/}
        {/*    alignItems: "center",*/}
        {/*    padding: "12px",*/}
        {/*    borderBottom: "1px solid #E2E6E8",*/}
        {/*    borderLeft: `7px solid ${nomination?.isNew ? "#4CAF50" : "#FFF"}`,*/}
        {/*    marginLeft: `0`*/}
        {/*  }}*/}
        {/*>*/}
        {/*  {history.location.pathname.indexOf("truck") > 0 && (*/}
        {/*    <>*/}
        {/*      <div className="ms-Grid-col ms-md2">*/}
        {/*        <div className={`truck-icon2`}>*/}
        {/*          {nomination.nominationType === "Load" && "L"}*/}
        {/*          {nomination.nominationType === "Discharge" && "O"}*/}
        {/*        </div>*/}
        {/*        <span className="list-item-title">{nomination.tank}</span>*/}
        {/*      </div>*/}
        {/*      <div className="ms-Grid-col ms-md1">{nomination.customerOrderNo}</div>*/}
        {/*      <div className="ms-Grid-col ms-md1" style={{ padding: 0 }}>*/}
        {/*        {nomination.loadingSpot}*/}
        {/*      </div>*/}
        {/*    </>*/}
        {/*  )}*/}
        {/*  {history.location.pathname.indexOf("rail") > 0 && (*/}
        {/*    <>*/}
        {/*      <div className="ms-Grid-col ms-md1">*/}
        {/*        <div className={`truck-icon2`}>*/}
        {/*          {nomination.nominationType === "Load" && "L"}*/}
        {/*          {nomination.nominationType === "Discharge" && "O"}*/}
        {/*        </div>*/}
        {/*        <span className="list-item-title">{nomination.tank}</span>*/}
        {/*      </div>*/}
        {/*      <div className="ms-Grid-col ms-md1" style={{ padding: 0 }}>*/}
        {/*        {nomination.railcars}*/}
        {/*      </div>*/}
        {/*      <div className="ms-Grid-col ms-md1" style={{ padding: 0 }}>*/}
        {/*        {nomination.loadingSpot}*/}
        {/*      </div>*/}
        {/*    </>*/}
        {/*  )}*/}
        {/*  <div className={`ms-Grid-col ms-md${history.location.pathname.indexOf("truck") > 0 ? '1' : '2'}`} style={{ color: "#4C4C4C" }}>*/}
        {/*    #{toNominationNo(nomination.nominationNo)}*/}
        {/*  </div>*/}
        {/*  <div className="ms-Grid-col ms-md2">*/}
        {/*    <input*/}
        {/*      type="text"*/}
        {/*      disabled={!props.isTruckUpdateAssignmentAllowed}*/}
        {/*      value={assignedTo}*/}
        {/*      onClick={(e) => e.stopPropagation()}*/}
        {/*      onChange={(e) => setAssignedTo(e.target.value)}*/}
        {/*      onBlur={() => updateAssignedTo(assignedTo)}*/}
        {/*      maxLength={30}*/}
        {/*      style={{*/}
        {/*        width: "100%",*/}
        {/*        padding: "5px 24px 5px 8px",*/}
        {/*        border: "1px solid #E2E6E8"*/}
        {/*      }}*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*{!(props.modality === 2 && props.selectedTab === "Expected") &&*/}
        {/*
         */}
        {/*}*/}
        {/*<div className="ms-Grid-col ms-md2">*/}
        {/*    <EtaButton*/}
        {/*        nomination={nomination}*/}
        {/*        onSuccess={(value: string) => {*/}
        {/*            nomination.eta = value;*/}
        {/*            props.onEtaUpdated(nomination);*/}
        {/*        }}*/}
        {/*    />*/}
        {/*</div>*/}
        {/*  <div*/}
        {/*    className="ms-Grid-col ms-md1 progress-item"*/}
        {/*    style={{ paddingLeft: "40px" }}*/}
        {/*  >*/}
        {/*    <RoundProgressIndicator value={nomination.progress} />*/}
        {/*  </div>*/}
        {/*  <div*/}
        {/*    className="ms-Grid-col ms-md2"*/}
        {/*    style={{*/}
        {/*      display: "flex",*/}
        {/*      flexDirection: "row-reverse"*/}
        {/*    }}*/}
        {/*  >*/}
        {/*    <div className={classes.viewButton}>*/}
        {/*      <Icon*/}
        {/*        iconName={isExpand ? "ChevronUp" : "ChevronDown"}*/}
        {/*        className={classes.viewIcon}*/}
        {/*      />*/}
        {/*    </div>*/}
        {/*    <Link*/}
        {/*      id={`lnk-${nomination.nominationNo}`}*/}
        {/*      className={classes.viewButton}*/}
        {/*      to={`${location.pathname}/${nomination.nominationNo}/sof`}*/}
        {/*    >*/}
        {/*      <svg*/}
        {/*          width="19"*/}
        {/*          height="21"*/}
        {/*          viewBox="0 0 19 21"*/}
        {/*          fill="none"*/}
        {/*          xmlns="http://www.w3.org/2000/svg"*/}
        {/*        >*/}
        {/*          <path*/}
        {/*            d="M6.2002 0.400391C5.56368 0.400391 4.95323 0.653247 4.50314 1.10333C4.05305 1.55342 3.8002 2.16387 3.8002 2.80039V9.04879C4.19245 8.93775 4.59418 8.86343 5.0002 8.82679V2.80039C5.0002 2.48213 5.12662 2.17691 5.35167 1.95186C5.57671 1.72682 5.88194 1.60039 6.2002 1.60039H11.0002V5.80039C11.0002 6.27778 11.1898 6.73562 11.5274 7.07318C11.865 7.41075 12.3228 7.60039 12.8002 7.60039H17.0002V17.2004C17.0002 17.5187 16.8738 17.8239 16.6487 18.0489C16.4237 18.274 16.1185 18.4004 15.8002 18.4004H11.4802C11.2618 18.8278 10.9974 19.2302 10.6918 19.6004H15.8002C16.4367 19.6004 17.0472 19.3475 17.4973 18.8974C17.9473 18.4474 18.2002 17.8369 18.2002 17.2004V6.89719C18.1998 6.41996 18.0099 5.96243 17.6722 5.62519L12.9754 0.92719C12.638 0.589969 12.1805 0.400492 11.7034 0.400391H6.2002ZM16.7518 6.40039H12.8002C12.6411 6.40039 12.4885 6.33718 12.3759 6.22465C12.2634 6.11213 12.2002 5.95952 12.2002 5.80039V1.84879L16.7518 6.40039ZM5.6002 20.8004C7.03236 20.8004 8.40588 20.2315 9.41857 19.2188C10.4313 18.2061 11.0002 16.8326 11.0002 15.4004C11.0002 13.9682 10.4313 12.5947 9.41857 11.582C8.40588 10.5693 7.03236 10.0004 5.6002 10.0004C4.16803 10.0004 2.79452 10.5693 1.78182 11.582C0.769122 12.5947 0.200195 13.9682 0.200195 15.4004C0.200195 16.8326 0.769122 18.2061 1.78182 19.2188C2.79452 20.2315 4.16803 20.8004 5.6002 20.8004ZM8.425 14.9756C8.53766 15.0883 8.60095 15.2411 8.60095 15.4004C8.60095 15.5597 8.53766 15.7125 8.425 15.8252C8.31233 15.9379 8.15953 16.0011 8.0002 16.0011C7.84086 16.0011 7.68806 15.9379 7.5754 15.8252L6.2002 14.4488V17.8004C6.2002 17.9595 6.13698 18.1121 6.02446 18.2247C5.91194 18.3372 5.75933 18.4004 5.6002 18.4004C5.44107 18.4004 5.28845 18.3372 5.17593 18.2247C5.06341 18.1121 5.0002 17.9595 5.0002 17.8004V14.4488L3.625 15.8252C3.51249 15.9379 3.35984 16.0012 3.20062 16.0013C3.0414 16.0014 2.88866 15.9383 2.776 15.8258C2.66333 15.7133 2.59997 15.5606 2.59986 15.4014C2.59975 15.2422 2.66289 15.0895 2.7754 14.9768L5.1754 12.5768C5.28706 12.4648 5.43843 12.4014 5.5966 12.4004H5.6038C5.76025 12.4011 5.91018 12.4631 6.0214 12.5732L6.025 12.5768L8.425 14.9768V14.9756Z"*/}
        {/*            fill="#7C7777"*/}
        {/*          />*/}
        {/*        </svg>*/}
        {/*    </Link>*/}
        {/*    */}
        {/* {props.isEditTimestampAllowed &&*/}
        {/*
         */}
        {/*      lineHandling.status >= 3 &&*/}
        {/*
         */}
        {/*      lineHandling.status != 6 && (*/}
        {/*
         */}
        {/*        <Link*/}
        {/*
         */}
        {/*          id={`lnk-${lineHandling.lineHandlingNo}`}*/}
        {/*
         */}
        {/*          className={classes.viewButton}*/}
        {/*
         */}
        {/*          to={`/review?linehandling=${lineHandling.lineHandlingNo}`}*/}
        {/*
         */}
        {/*          title="Review Line Handling"*/}
        {/*
         */}
        {/*          style={{ padding: "7px 5px" }}*/}
        {/*
         */}
        {/*        >*/}
        {/*
         */}
        {/*          <SofIcon*/}
        {/*
         */}
        {/*            iconname="Starburst"*/}
        {/*
         */}
        {/*            className={classes.viewIcon}*/}
        {/*
         */}
        {/*            style={{ margin: "auto" }}*/}
        {/*
         */}
        {/*          />*/}
        {/*
         */}
        {/*        </Link>*/}
        {/*
         */}
        {/*      )} */}
        {/*    <div className={classes.viewButtonUpload}>*/}
        {/*      <Icon*/}
        {/*        iconName="Attach"*/}
        {/*        className={classes.viewIconUpload}*/}
        {/*        onClick={(e) => {*/}
        {/*          e.stopPropagation();*/}
        {/*          e.preventDefault();*/}
        {/*          setSelectedNomination(nomination.nominationNo);*/}
        {/*          openAttachmentPanel();*/}
        {/*        }}*/}
        {/*      />*/}
        {/*    </div>*/}

        {/*    {nomination.isRejected && (*/}
        {/*      <span*/}
        {/*        className={classes.ovalRejected}*/}
        {/*        id={`callOut_${nomination.nominationNo}`}*/}
        {/*        onClick={(e) => {*/}
        {/*          e.stopPropagation();*/}
        {/*          setCallOutId(nomination.nominationNo);*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        Rejected*/}
        {/*      </span>*/}
        {/*    )}*/}
        {/*    {callOutId === nomination.nominationNo && (*/}
        {/*      <Callout*/}
        {/*        className={classes.callout}*/}
        {/*        target={`#callOut_${nomination.nominationNo}`}*/}
        {/*        onDismiss={() => setCallOutId("")}*/}
        {/*        role="status"*/}
        {/*        aria-live="assertive"*/}
        {/*      >*/}
        {/*        <DelayedRender>*/}
        {/*          <div>*/}
        {/*            <div*/}
        {/*              className="list-item-title"*/}
        {/*              style={{ marginLeft: "0px", marginBottom: "10px" }}*/}
        {/*            >*/}
        {/*              Reason for Rejection*/}
        {/*            </div>*/}
        {/*            <br />*/}
        {/*            {nomination.rejectReason}*/}
        {/*          </div>*/}
        {/*        </DelayedRender>*/}
        {/*      </Callout>*/}
        {/*    )}*/}
        {/*  </div>*/}
        {/*</div>*/}
      </div>
    </>
  );
};
export default connect(
  (state: State) => ({
    ...state.general,
  }),
  SofViewStore.actionCreators
  // @ts-ignore
)(NominationItem2);
